/* eslint-disable jsx-a11y/anchor-is-valid */
import {useLazyQuery} from '@apollo/client'
import React, {useEffect, useState} from 'react'
import {
  GET_AGENT_PRODUCT_AND_FILTER,
  GET_CUSTOMER_ENROLLMENT_DATA,
} from '../../../../../utils/GraphQLAPI'
import {StepCustomerProps} from '../InterfaceAgentModal'
import '../../agent.scss'
import FormFields from '../FormFields'
import {GLOBAL_CONSTANTS} from '../../../../../utils/GlobalConstants'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
const MySwal = withReactContent(Swal)
const CustomerInfo = ({
  hasError,
  handleClose,
  isSolarProduct,
  formik,
  hasFieldError,
  isCommercialCustomer,
  setIsCommercialCustomer,
  isExistingCustomer,
  SetIsExistingCustomer,
  defaultAgentEnrollment,
  mode,
  searchText,
  setSearchText,
  customer,
  setCustomer,
  getCustomerByPhoneNumber,
  customerLoading,
  customerData,
  isServiceSameAsBill,
  setIsServiceSameAsBill,
  bussinessRef,
  featureFlags,
  setSendContract,
  sendContract,
  sendContractEmail,
  setSendContractEmail,
  customerFeatureFlags,
  isOptedIn,
  setDocumentDelivery,
  triggerOptinAlert,
  setUtilities,
  setCustomerType,
  customerType,
  sendContractMessgae,
  setSendContractMessage,
}: StepCustomerProps) => {
  // const [customerType, setCustomerType] = useState<any>()

  // formik.customerType
  useEffect(() => {
    // getCustomerData()
  }, [hasError, hasFieldError])

  useEffect(() => {
    if (!isExistingCustomer && mode === 'create') {
      formik.setValues({...defaultAgentEnrollment})
      setSearchText('')
      if (!!searchText) {
        getCustomerByPhoneNumber({variables: {uanOrPhoneNumber: null}})
      }
      setCustomer('')
    }
  }, [isExistingCustomer])
  useEffect(() => {
    if (!isCommercialCustomer) {
      formik.setFieldValue('businessName', '')
    } else {
      makeManualBusinessBlur()
    }
  }, [isCommercialCustomer])

  const [getCustomerData, {data: getcustomerByIdData}] = useLazyQuery(
    GET_AGENT_PRODUCT_AND_FILTER,
    {
      fetchPolicy: GLOBAL_CONSTANTS.networkOnly,
      variables: {
        input: {
          gasProductFilters: {
            page: 1,
            perPage: 150,
            brandTypeId: null,
            commodityId: null,
            contractTypeId: null,
            customerTypeId: null,
            electricProductId: null,
            utilityId: null,
          },
          isMixMatch: false,
          productFilters: {
            page: 1,
            perPage: 150,
            brandTypeId: null,
            commodityId: null,
            contractTypeId: null,
            customerTypeId: null,
            utilityId: null,
          },
        },
      },
      onCompleted: (customerData1) => {
        setCustomerType(
          customerData1.getAgentProductsAndFilter.productFilters.customerTypes.map(
            (types: any) => ({
              id: types.id,
              value: types.name,
            })
          )
        )
      },
      onError: (error) => {
        MySwal.fire({
          icon: 'error',
          text: error.message,
          allowOutsideClick: false,
          preConfirm: () => {
            handleClose()
          },
        })
      },
    }
  )

  useEffect(() => {
    getCustomerData()
  }, [])
  const inputRef = React.useRef() as React.MutableRefObject<HTMLInputElement>
  const billingAddressRef = React.useRef() as React.MutableRefObject<HTMLInputElement>
  //helper fn to handle service address same as billing address
  const handleOnChecked = (e: any) => {
    const isChecked = e.target.checked
    setIsServiceSameAsBill(e.target.checked)
    if (isChecked) {
      formik.setFieldValue('billingAddress', formik.getFieldMeta('serviceAddress').value)
      formik.setFieldValue('billingAddress2', formik.getFieldMeta('serviceAddress2').value)
      formik.setFieldValue('billingCountry', formik.getFieldMeta('serviceCountry').value)
      formik.setFieldValue('billingState', formik.getFieldMeta('serviceState').value)
      formik.setFieldValue('billingCity', formik.getFieldMeta('serviceCity').value)
      formik.setFieldValue('billingZipCode', formik.getFieldMeta('serviceZipCode').value)
      formik.setFieldValue('billingUnitNumber', formik.getFieldMeta('serviceUnitNumber').value)
    } else {
      formik.setFieldValue('billingAddress', '')
      formik.setFieldValue('billingAddress2', '')
      formik.setFieldValue('billingCountry', '')
      formik.setFieldValue('billingState', '')
      formik.setFieldValue('billingCity', '')
      formik.setFieldValue('billingZipCode', '')
      formik.setFieldValue('billingUnitNumber', '')
      // Mark the fields as touched
      formik.setTouched({
        billingAddress: true,
        billingAddress2: true,
        billingCountry: true,
        billingState: true,
        billingCity: true,
        billingZipCode: true,
        billingUnitNumber: true,
      })
    }
    setTimeout(() => makeManualBillingBlur(), 1)
  }

  const makeManualBusinessBlur = () => {
    bussinessRef?.current?.focus()
    bussinessRef?.current?.blur()
  }
  const makeManualBillingBlur = () => {
    billingAddressRef?.current?.focus()
    billingAddressRef?.current?.blur()
  }

  return (
    <div className='' data-kt-stepper-element='content'>
      <div className='w-100'>
        <div className='fv-row mb-10'>
          <label className='d-flex align-items-center fs-4 fw-bold mb-4 lh-1'>
            <span>Customer Details</span>
          </label>
        </div>

        {/* Modal Header Start */}

        {/* Modal Header End */}
        <div className='h-350px hover-scroll-overlay-y px-lg-5'>
          <FormFields
            isSolarProduct={isSolarProduct}
            formik={formik}
            businessRef={bussinessRef}
            hasFieldError={hasFieldError}
            isServiceSameAsBill={isServiceSameAsBill}
            isCommercialCustomer={isCommercialCustomer}
            setIsCommercialCustomer={setIsCommercialCustomer}
            customerType={customerType}
            inputRef={inputRef}
            handleOnChecked={handleOnChecked}
            billingRef={billingAddressRef}
            featureFlags={featureFlags}
            setSendContract={setSendContract}
            sendContract={sendContract}
            sendContractEmail={sendContractEmail}
            setSendContractEmail={setSendContractEmail}
            mode={mode}
            customerFeatureFlags={customerFeatureFlags}
            isOptedIn={isOptedIn}
            triggerOptinAlert={triggerOptinAlert}
            setDocumentDelivery={setDocumentDelivery}
            setUtilities={setUtilities}
            sendContractMessgae={sendContractMessgae}
            setSendContractMessage={setSendContractMessage}
          />
        </div>
      </div>
    </div>
  )
}

export {CustomerInfo}
